// Content by default has a padding according to its container
// However, there are some sections that are indented, this adds a constant variable to determine that padding

// e.g. https://www.figma.com/design/18Z5rAyXCnqIz5kJXqwUqq/Hoxton-Mix---White-label?node-id=4260-23250&m=dev
export const sectionPadding = 'px-xxl-32 px-xxxl-16'

// e.g. https://www.figma.com/design/18Z5rAyXCnqIz5kJXqwUqq/Hoxton-Mix---White-label?node-id=3836-7216&m=dev
export const sectionPaddingLarge = 'px-md-34'

export const heroGap = 'gap-xxxl-32 gap-lg-6 gap-12'
export const heroGapMd = 'gap-xxxl-26 gap-12'
export const sectionGap = 'gap-md-47 gap-14'
export const marginHeader = 'mb-md-20 mb-6'
export const sectionGapSmall = 'gap-8'
export const sectionIndent = 'px-xxl-35'
